import React, { Component } from 'react'
import ReactGA from 'react-ga'
import * as Sentry from '@sentry/browser'
import styled from 'styled-components/macro'

const Base = styled.section`
  max-width: 520px;
  padding: 1em;
  margin: auto;
  button {
    text-decoration: underline;
    color: #5050ea;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }
`

export default class ErrorBoundary extends Component {
  state = { error: null }

  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    ReactGA.exception({
      description: error && error.message,
      fatal: true,
    })
    if (process.env.NODE_ENV !== 'production') return
    Sentry.configureScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key])
      })
    })
    Sentry.captureException(error)
  }

  render() {
    if (this.state.error) {
      return (
        <Base>
          <h2>Opps!</h2>
          <p>Looks like we ran into an issue.</p>
          <p>
            Could you{' '}
            <button onClick={() => Sentry.showReportDialog()}>
              tell us a bit more
            </button>{' '}
            about what you were doing when this happened?
          </p>
          {this.props.nextAction}
        </Base>
      )
    } else {
      return this.props.children
    }
  }
}
